interface EmptyStateProps {
  onClearFilters?: () => void;
}

export function EmptyState({ onClearFilters }: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center p-8 text-center select-none py-12">
      {/* CSS-based glowing neon empty outline graphics */}
      <div className="relative w-20 h-20 mb-6 flex items-center justify-center">
        {/* Glow ring */}
        <div className="absolute inset-0 rounded-full bg-purple-600/5 border border-purple-500/10 animate-pulse shadow-glow" />
        {/* Floating cross grids */}
        <span className="text-4xl filter drop-shadow-[0_0_8px_rgba(168,85,247,0.5)]">
          📭
        </span>
      </div>

      <h3 className="font-display text-base font-black text-white uppercase tracking-wider mb-2">
        No Matches Found
      </h3>
      <p className="text-surface-400 text-xs font-semibold max-w-xs leading-relaxed mb-6">
        No previous match records match the search keyword or active tab filters.
      </p>

      {onClearFilters && (
        <button
          onClick={onClearFilters}
          className="px-6 py-2.5 rounded-full bg-white/5 hover:bg-white/10 border border-white/10 text-[9px] font-black uppercase tracking-widest text-surface-200 hover:text-white transition-colors cursor-pointer"
        >
          Reset Filters
        </button>
      )}
    </div>
  );
}
export default EmptyState;
